'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_PurchaseOrderReferenceForm(number, issueDate) {
  this.FD = null;
  this.FC = null;
  this.FD = number;
  this.FC = issueDate;
}
export { $c_Lapp_data_PurchaseOrderReferenceForm as $c_Lapp_data_PurchaseOrderReferenceForm };
$p = $c_Lapp_data_PurchaseOrderReferenceForm.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_PurchaseOrderReferenceForm;
/** @constructor */
function $h_Lapp_data_PurchaseOrderReferenceForm() {
}
export { $h_Lapp_data_PurchaseOrderReferenceForm as $h_Lapp_data_PurchaseOrderReferenceForm };
$h_Lapp_data_PurchaseOrderReferenceForm.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_PurchaseOrderReferenceForm)) {
    if ((this.FD === x$0.FD)) {
      var x = this.FC;
      var x$2 = x$0.FC;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "PurchaseOrderReferenceForm";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.FD;
  }
  if ((n === 1)) {
    return this.FC;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "number";
  }
  if ((n === 1)) {
    return "issueDate";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_PurchaseOrderReferenceForm(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jU)));
}
export { $isArrayOf_Lapp_data_PurchaseOrderReferenceForm as $isArrayOf_Lapp_data_PurchaseOrderReferenceForm };
var $d_Lapp_data_PurchaseOrderReferenceForm = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_PurchaseOrderReferenceForm, "app.data.PurchaseOrderReferenceForm", ({
  jU: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_PurchaseOrderReferenceForm as $d_Lapp_data_PurchaseOrderReferenceForm };
//# sourceMappingURL=app.data.-Purchase-Order-Reference-Form.js.map
